var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagoda-card-list"},[_vm._t("default"),_vm._l((_vm.emptyItems),function(i){return _c('card-list-item',{key:("emptyItem_" + i),staticClass:"pagoda-card-list-empty-item"})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }